// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".drawer-tpl-view{padding:20px 20px}.drawer-tpl-view .message-preview-container{height:auto !important}@media only screen and (min-width: 768px){.drawer-tpl-view{padding:20px 40px}}.drawer-folder-view{background:red}\n", ""]);
// Exports
module.exports = exports;
